// extracted by mini-css-extract-plugin
export default {"mobileNavigation":"mobile-navigation_mobileNavigation__WeX-g","globalHeaderItem":"mobile-navigation_globalHeaderItem__DT93s"};